<template>
  <div class="flex justify-center">
    <div class="box flex flex-col sm:flex-row gap-4 p-4 md:p-6 rounded-2xl bg-slate-50 border border-slate-100 shadow-card max-w-2xl w-full">
      <div class="image flex-1">
        <img class="rounded-xl w-full shadow-md" src="../assets/pp1.jpg" alt="Boost VPN app screenshot 1" />
      </div>
      <div class="image flex-1">
        <img class="rounded-xl w-full shadow-md" src="../assets/pp2.jpg" alt="Boost VPN app screenshot 2" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BoxPage',
}
</script>
